var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGridRowActionsCell } from './data-grid-row-actions-cell';
var cls = classNames('data-grid-row');
export var DataGridRowDefaultProps = {
  actions: ['delete']
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    border-bottom: 1px solid ", ";\n  "], ["\n    height: 100%;\n    border-bottom: 1px solid ", ";\n  "])), theme.COLOR('line-subtle'))
});
var ActionsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: sticky;\n    right: 0;\n    z-index: 2; /* Ensure it stays above other cells */ \n\n  "], ["\n    position: sticky;\n    right: 0;\n    z-index: 2; /* Ensure it stays above other cells */ \n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'DataGridRow',
  Container: styled.tr(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Actions: styled(DataGridRowActionsCell)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ActionsStyles)
};
export var DataGridRow = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridRowDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    actions = componentProps.actions,
    onButtonAction = componentProps.onButtonAction;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, children, React.createElement(My.Actions, {
    hasLeftBorder: true,
    actions: actions,
    onButtonAction: onButtonAction
  }));
};
DataGridRow.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;